import React from 'react';

export default function RequiredIndicator() {
  return <span style={{ color: '#D24A4A' }}>*</span>;
}
